/*
 * Polyfill stable language features.
 * It's recommended to use @babel/preset-env and browserslist
 * to only include the polyfills necessary for the target browsers.
 */
import "core-js/stable";
import "core-js/es/object/has-own";
import "regenerator-runtime/runtime";

/**
 * FIXME Remove these global.crypto and `window.crypto` hacks.
 * https://linear.app/clipboardhealth/issue/FEF-155/remove-windowcrypto-and-directly-use-uuid-package
 */
if (!global.crypto) {
  global.crypto = {} as Crypto;
}
if (!window.crypto?.randomUUID) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  window.crypto.randomUUID = require("uuid").v4;
}
/**
 * This file contains polyfills loaded on all browsers
 **/
